export const API_URL = "https://api.lorangedenoel.fr/api/"
// export const API_URL = "http://localhost:3001/api/"
